<script setup>
/**
 * The connection-state marker on a Settings channel leaf.
 *
 * Text.com renders these as bare coloured uppercase text rather than filled
 * chips, which keeps a column of eight of them quiet enough to scan.
 */
import { computed } from 'vue';

const props = defineProps({
  state: {
    type: String,
    required: true,
    validator: value => ['on', 'off', 'soon'].includes(value),
  },
});

const TONES = {
  on: 'text-n-teal-11',
  off: 'text-n-slate-10',
  soon: 'text-n-blue-11',
};

const LABELS = {
  on: 'SIDEBAR.CHANNEL_STATE.ON',
  off: 'SIDEBAR.CHANNEL_STATE.OFF',
  soon: 'SIDEBAR.CHANNEL_STATE.SOON',
};

const tone = computed(() => TONES[props.state]);
const labelKey = computed(() => LABELS[props.state]);
</script>

<template>
  <span
    class="flex-shrink-0 text-[10px] font-semibold uppercase tracking-wide"
    :class="tone"
  >
    {{ $t(labelKey) }}
  </span>
</template>
